
























import { Component, Vue } from 'vue-property-decorator';
import EventBus from '@/EventBus';
import { storeService } from '@/services/StoreService';

@Component({})
export default class RemoveWorkspaceDialogConfirmation extends Vue {
  isModalShown = false;
  isSuccessfullyRemoved = false;
  removalHasFailed = false;

  onClose() {
    this.isModalShown = false;
  }
  mounted() {
    this.isModalShown = false;
    EventBus.$on('delete-workspace-success', (data: any) => {
      EventBus.$emit('workspace-delete-success');
      this.isSuccessfullyRemoved = true;
      this.isModalShown = true;
    });
    EventBus.$on('billing_period_repayment_failed', (data: any) => {
      storeService.getWorkspaces().then((data: any) => {
        const workspaceId = parseInt(this.$route.params.workspaceId, 10);
        const workspace = data.workspaces.find((item: any) => item.id === workspaceId);
        if (workspace && workspace.blocked && workspace.system_block_reason === 'deletion') {
          EventBus.$emit('workspace-delete-failed');
          this.removalHasFailed = true;
          this.isModalShown = true;
        }
      });
    });
  }
}
